import * as React from 'react'
import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetContentDescription,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
} from 'components/ModalSheet'
import Button from 'components/Button'
import OCRConfirmBulkReviewModalViewModel from './OCRConfirmBulkReviewModalViewModel'

/**
 * Confirm Bulk Review Modal
 */
export default observer(function OCRConfirmBulkReviewModal({
  vm,
}: {
  vm: OCRConfirmBulkReviewModalViewModel
}) {
  return (
    <ModalSheet
      showing={vm.showing}
      onRequestClose={vm.close}
      disableCloseOnOutsideClick
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={require('assets/images/img_create-flows.svg')}
          />
          <ModalSheetContentTitle>
            You are about to set{' '}
            {vm.ocrScopingJobBulkActionViewModel.bulkActionSelectedCount} jobs
            as ready to submit
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Are you sure you want to proceed? Once you change the status, the
            Firm Admin will be able to review and submit these jobs.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button onClick={vm.close}>Close</Button>
          <Button
            type="primary"
            onClick={vm.confirm}
            disabled={vm.ocrScopingJobBulkActionViewModel.bulkReview.pending}
          >
            Set As Ready To Submit
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
